export * from './block-input/block-copy-past.directive';
export * from './directive.module';
export * from './input-mask/input-mask.directive';
export * from './input-remove/input-remove.directive';
export * from './press-hold/press-hold.directive';
export { ConnectorSqlitePwaProvider } from './provider/connector-sqlite-pwa.provider';
export { DateUtilProvider } from './provider/date-util-provider';
export { IonUtilsProvider } from './provider/ion-utils-provider';
export { IonValidateFilds } from './provider/ion-validate-filds';
export * from './tap/tap.directive';
